import React from 'react';

import { useAppDispatch, useAppSelector } from 'segments/hooks';

import { changeActiveModal, selectActiveModal } from 'features/modals';

import { BookingWaitListModal, CreateBookingWaitModal, EditBookingWaitModal } from 'widgets/bookingWait';
import { CreateCoachModal, EditCoachModal } from 'widgets/coaches';
import { AddUserToBooking, BookedCourtDetailModal, BookingCourtModal, EditCourtBooking } from 'widgets/courtsBooking';
import { CreateImageModal } from 'widgets/imagesStore';
import { EditUserModal, WalletsOperationsModal, SelectUserGroupeModal, GroupePayment, CreateUserModal } from 'widgets/users';

function DashboardModals() {
  const dispatch = useAppDispatch();
  const activeModal = useAppSelector(selectActiveModal);
  const closeModal = () => dispatch(changeActiveModal(null));

  switch (activeModal) {
    case 'edit-coach-modal':
      return (
        <EditCoachModal
          key={'editCoach'}
          handleCancel={closeModal}
        />
      );
    case 'create-coach-modal':
      return (
        <CreateCoachModal
          key={'createCoach'}
          handleCancel={closeModal}
        />
      );
    case 'balance-operations':
      return (
        <WalletsOperationsModal
          key='balanceOperations'
          handleCancel={closeModal}
        />
      );
    case 'edit-user-modal':
      return (
        <EditUserModal
          key='editUserModal'
          handleCancel={closeModal}
        />
      );
    case 'select-user-groupe':
      return (
        <SelectUserGroupeModal
          key='selectUserGroupe'
          handleCancel={closeModal}
        />
      );
    case 'user-groupe-payment':
      return (
        <GroupePayment
          key='groupePayment'
          handleCancel={closeModal}
        />
      );
    case 'create-user':
      return (
        <CreateUserModal
          key='createUser'
          handleCancel={closeModal}
        />
      );
    case 'create-booking-wait-modal':
      return (
        <CreateBookingWaitModal
          key='createBookingWaitModal'
          handleCancel={closeModal}
        />
      );
    case 'edit-booking-wait-modal':
      return (
        <EditBookingWaitModal
          key='EditBookingWaitModal'
          handleCancel={closeModal}
        />
      );
    case 'booking-wait-list-modal':
      return (
        <BookingWaitListModal
          key='EditBookingWaitModal'
          handleCancel={closeModal}
        />
      );
    case 'booked-court-detail-modal':
      return (
        <BookedCourtDetailModal
          key='BookedCourtDetailModal'
          handleCancel={closeModal}
        />
      );
    case 'booking-court-modal':
      return (
        <BookingCourtModal
          key='BookingCourtModal'
          handleCancel={closeModal}
        />
      );
    case 'add-user-to-booking':
      return (
        <AddUserToBooking
          key='BookingCourtModal'
          handleCancel={closeModal}
        />
      );
    case 'edit-booked-court':
      return (
        <EditCourtBooking
          key='EditBookedCourt'
          handleCancel={closeModal}
        />
      );
    case 'create-image-modal':
      return (
        <CreateImageModal
          key='CreateImageModal'
          handleCancel={closeModal}
        />
      );
    default:
  }
}

export default DashboardModals;
